import React, { useEffect, useRef, useState } from "react";
import FormUI from '@/componentsUI/Form';
import { feedback } from "@/utils/feedback";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  useWalletAll,
  useWalletWithdrawFlat,
  useWithdrawFlat,
} from "@/store/walletStore";
import { useUserInfo } from "@/store/userInfo";
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import WidthdrawCurrency from "../compoments/widthdrawCurrency/WidthdrawCurrency";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import { IFInitWalletWithdrawFlatReq } from "@/api/apiReq/IFWalletReq";
import { sys } from "@/Core/utils/system";
import WidthdrawPix from "../pix/WidthdrawPix";
import {
  IFInitWalletRsp,
  IFInitWalletWithdrawFlatRsp,
} from "@/api/apiRsp/IFWalletRsp";
import ButtonUI from "@/componentsUI/Button";
import "../index.less";
import useDialogManager from "@/utils/useDialogManager";
import {
  AmountMultiplierConversion,
  dealAmount9Valid,
} from "@/Core/utils/currencyDealCenter";
import useDialog from "@/utils/useDialog";
import WidthdrawWay from "../compoments/widthdrawWay/WidthdrawWay";
import WidthdrawedPix from "../pix/WidthdrawedPix";
import MobileInput from "../compoments/mobileInput/MobileInput";
import { getWithdrawalMobile } from "@/utils/mobileUtils";
import PaymentMethodSelector from "@/pages/wallet/shared/PaymentMethodSelector";
import { sortPaymentMethods } from "@/pages/wallet/shared/PaymentMethodUtils";
import WithdrawConfirmModal from "../compoments/WithdrawConfirmModal/WithdrawConfirmModal";
import { runWithdrawalOfficialAppPrompt } from "@/features/install/withdrawalOfficialAppPrompt";

const FlatWithdrawTanzania = () => {
  const [form] = FormUI.useForm();
  const { t } = useTranslationPlus();
  const { data: wallets } = useWalletAll();
  const { data: userInfo } = useUserInfo();
  const formValidateRef = useRef(null);
  const [params, setParams] = useState<IFInitWalletWithdrawFlatReq>(
    wallets?.flat
      ? {
          currencyType:
            wallets?.flat[0]?.serverCurrencyType ||
            wallets?.flat[0]?.currencyType,
          device: sys.device,
        }
      : null
  );
  const { data, isValidating, error, mutate } = useWithdrawFlat(params);
  const [currentWallet, setCurrentWallet] = useState<IFInitWalletRsp>(
    wallets?.flat?.[0]
  );

  const [widthdrawConfig, setWidthdrawConfig] =
    useState<IFInitWalletWithdrawFlatRsp>();

  const [selectedWithdrawType, setSelectedWithdrawType] = useState<number>(102);
  const [bankType, setBankType] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingWithdrawData, setPendingWithdrawData] = useState(null);

  const getWithdrawChannels = (type = selectedWithdrawType): string[] => {
    const config = data?.configParams?.find((c) => c.withdrawType === type);
    const accountType = config?.options?.accountType;
    if (!accountType) return [];
    if (Array.isArray(accountType)) return accountType;
    return accountType.split(",").map((s: string) => s.trim());
  };

  function changeWidthdraw(index) {
    const item = wallets.flat?.[index];
    if (!item) {
      return;
    }
    setParams({
      currencyType: item.serverCurrencyType || item.currencyType,
      device: sys.device,
    });
    setCurrentWallet(item);
  }

  useEffect(() => {
    if (wallets?.flat?.length) {
      form.setFieldValue("walletType", wallets?.flat?.[0]?.currencyType);
    }
  }, [wallets]);

  useEffect(() => {
    form.setFieldValue(
      "mobile",
      getWithdrawalMobile(userInfo?.mobile, userInfo?.userId)
    );
  }, [userInfo]);

  // Initialize type, config and default bankType when API data loads.
  useEffect(() => {
    if (!data?.configParams?.length) return;

    const availableTypes = data.configParams.map((c) => c.withdrawType);
    const initialType = availableTypes.includes(102) ? 102 : availableTypes[0];
    const initialConfig =
      data.configParams.find((c) => c.withdrawType === initialType) ||
      data.configParams[0];

    setSelectedWithdrawType(initialType);
    setWidthdrawConfig(initialConfig);
    form.setFieldValue("witdrawWay", {
      type: initialConfig.withdrawType,
      data: initialConfig,
    });

    const channels = sortPaymentMethods(getWithdrawChannelsFor(initialType, data.configParams));
    setBankType(channels[0] ?? "");
  }, [data]);

  function changeType({ data: cfg }: { data: IFInitWalletWithdrawFlatRsp }) {
    setWidthdrawConfig(cfg);
    setSelectedWithdrawType(cfg.withdrawType);
    const channels = sortPaymentMethods(getWithdrawChannelsFor(
      cfg.withdrawType,
      data?.configParams
    ));
    setBankType(channels[0] ?? "");
  }

  const { trigger } = useWalletWithdrawFlat();
  const { openGoogleTowFactor } = useDialogManager();
  const { closeAll } = useDialog();

  const pixWidthdraw = (v) => {
    const cpf = v?.cpf?.replaceAll(".", "").replaceAll("-", "");
    const selectedWallet = wallets?.flat?.find(
      (wallet) => wallet.currencyType === v.walletType
    );
    const accountInfo: any = {
      pixFullName: v.userInfo?.fullName || v.accountName,
      pixCpf: cpf,
      pixType: bankType,
      pixAccount: cpf,
    };
    if (v.userInfo?.email && v.userInfo.email.trim() !== "") {
      accountInfo.email = v.userInfo.email;
    }
    const requestParams = {
      currencyType: selectedWallet?.serverCurrencyType || v.walletType,
      money: AmountMultiplierConversion(Math.floor(v.amount), {
        currencyType: selectedWallet?.currencyType,
        serverCurrencyType: selectedWallet?.serverCurrencyType,
      }),
      withdrawType: selectedWithdrawType,
      accountInfo: JSON.stringify(accountInfo),
      accountType: bankType,
      mobile: v.mobile,
      withdrawMobileUserId: userInfo?.userId,
    };
    trigger(requestParams)
      .then((res) => {
        if (res?.googleAuth) {
          openGoogleTowFactor({
            trigger: trigger,
            params: requestParams,
            complete: () => {
              closeAll();
            },
          });
        } else {
          closeAll();
        }
      })
      .catch((e) => {
        if (e?.code == "ERROR_60028") {
          if (e?.data?.withdrawAmount == 0) {
            feedback.error(
              t("WITHDRAW_NEED_BET", {
                betCode: dealAmount9Valid(e?.data?.betTarget, {
                  currencyType: e?.data?.currency,
                }),
              })
            );
          } else {
            feedback.error(
              t("WITHDRAW_ALREADY_BET", {
                alreadyCode: dealAmount9Valid(e?.data?.withdrawAmount, {
                  currencyType: e?.data?.currency,
                }),
              })
            );
          }
        } else {
          feedback.error(t(e?.code));
        }
      });
  };

  const onClickWidthdraw = () => {
    formValidateRef.current = true;
    form
      .validate()
      .then((v) =>
        runWithdrawalOfficialAppPrompt({
          stage: "before_submit",
          userId: userInfo?.userId,
          onContinue: () => {
            setPendingWithdrawData(v);
            setShowConfirmModal(true);
          },
        }),
      )
      .finally(() => {
        formValidateRef.current = false;
      });
  };

  const handleWithdrawConfirm = (confirmData: {
    fullName: string;
    email?: string;
  }) => {
    if (pendingWithdrawData) {
      pixWidthdraw({ ...pendingWithdrawData, userInfo: confirmData });
    }
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  const handleWithdrawClose = () => {
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  return (
    <div className="flat-widthdraw">
      <FormUI form={form} layout={"vertical"} autoComplete={"off"}>
        <FromItemPlus
          field={"walletType"}
          label={t("Wallet.WithdrawCurrencyTitle")}
        >
          <WidthdrawCurrency
            currencys={wallets?.flat}
            onChange={(_value: any, option: any) => {
              changeWidthdraw(option?._index);
            }}
          />
        </FromItemPlus>

        <LoadingUI
          isLoading={isValidating}
          error={error}
          dataList={data}
          retryFunc={mutate}
          className="wallet-flat-loading-state"
        >
          <>
            {(data?.configParams?.length ?? 0) > 1 && (
              <FromItemPlus
                field={"witdrawWay"}
                label={t("Wallet.Withdraw payWay")}
              >
                <WidthdrawWay
                  configs={data?.configParams}
                  onChange={changeType}
                />
              </FromItemPlus>
            )}

            {selectedWithdrawType === 102 && (
              <div className="withdraw-method-section">
                <label className="method-label">
                  <span className="withdraw-required-mark">*</span>
                  <span>{t("Wallet.Method")}</span>
                </label>
                <PaymentMethodSelector
                  methods={getWithdrawChannels(102)}
                  selectedMethod={bankType}
                  onMethodSelect={setBankType}
                  className="withdraw-bank-selector"
                />
              </div>
            )}

            {selectedWithdrawType === 104 && (
              <div className="withdraw-method-section">
                <label className="method-label">
                  <span className="withdraw-required-mark">*</span>
                  <span>{t("Wallet.Method")}</span>
                </label>
                <PaymentMethodSelector
                  methods={getWithdrawChannels(104)}
                  selectedMethod={bankType}
                  onMethodSelect={setBankType}
                  className="withdraw-bank-selector"
                />
              </div>
            )}

            {(selectedWithdrawType === 102 || selectedWithdrawType === 104) && (
              <div className="withdraw-mobile-section">
                <FromItemPlus
                  field={"mobile"}
                  label={t("Wallet.Mobile Number")}
                  className="withdraw-mobile-item"
                  rules={[
                    {
                      required: true,
                      message: t("Wallet.Please enter mobile number"),
                    },
                    {
                      validator: (value, cb) => {
                        if (value && value.length !== 9) {
                          return cb("Mobile number must be 9 digits");
                        }
                        return cb();
                      },
                    },
                  ]}
                >
                  <MobileInput disabled={false} />
                </FromItemPlus>
                <div className="important-notice">
                  {t("Wallet.WithdrawPhoneNotice")}
                </div>
              </div>
            )}

            {selectedWithdrawType === 102 && (
              <WidthdrawPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
            {selectedWithdrawType === 104 && !data?.userAccount?.pixCpf && (
              <WidthdrawPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
            {selectedWithdrawType === 104 && data?.userAccount?.pixCpf && (
              <WidthdrawedPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
          </>
        </LoadingUI>
      </FormUI>
      <ButtonUI
        className={`widthdraw-btn`}
        type="primary"
        onClick={onClickWidthdraw}
      >
        {t("Wallet.Withdraw")}
      </ButtonUI>
      <WithdrawConfirmModal
        visible={showConfirmModal}
        onClose={handleWithdrawClose}
        onConfirm={handleWithdrawConfirm}
        withdrawData={pendingWithdrawData}
      />
    </div>
  );
};

// Parse channels from configParams for a given withdrawType.
function getWithdrawChannelsFor(
  type: number,
  configParams: IFInitWalletWithdrawFlatRsp[] | undefined
): string[] {
  const config = configParams?.find((c) => c.withdrawType === type);
  const accountType = config?.options?.accountType;
  if (!accountType) return [];
  if (Array.isArray(accountType)) return accountType;
  return accountType.split(",").map((s: string) => s.trim());
}

export default FlatWithdrawTanzania;
